import { connect } from 'react-redux';
import { SEARCH } from 'constants/filter-sets';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { filterSetFilters } from 'redux/saga/selectors';
import { deepExtract } from 'helpers/deep';
import {
  selectLocationAutocompleteValueInLayout,
  selectDataFromResultsLayout,
  selectTotalHitsInLayout,
  selectMetadataInLayout,
} from './Search.helpers';
import { ResultTypeSelector } from './components/ResultTypeSelector';
import { FILTER_NAMES } from './Search.constants';
import { selectSelectedVertical } from './filters/filters.helpers';
import { doLoadResultType } from './filters/filters.saga';
import { resultTypeClicked, watchResultType } from './ResultTypeSelector.saga';

const { RESULT_TYPE } = FILTER_NAMES;

export const mapStateToProps = state => {
  const filters = filterSetFilters(state, SEARCH);
  const resultsFromLayout = selectDataFromResultsLayout(state);
  const selectedVertical = selectSelectedVertical(state);
  const filterMetadata = selectMetadataInLayout(resultsFromLayout);
  const venueResultsHeaderText = filterMetadata.header1;

  return {
    vertical: selectedVertical,
    selectedResultType: deepExtract(`${RESULT_TYPE}.value`, filters),
    totalResults: selectTotalHitsInLayout(resultsFromLayout),
    locationName: selectLocationAutocompleteValueInLayout(resultsFromLayout),
    venueResultsHeaderText,
  };
};

export const mapDispatchToProps = {
  onResultTypeClicked: resultTypeClicked,
};

export const ResultTypeSelectorContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSagas({
    load: doLoadResultType,
    watch: watchResultType,
  }),
  withName('ResultTypeSelectorContainer')
)(ResultTypeSelector);
